<ng-template #tmp>
    <fal [i]="icon" class="label-icon text-{{invalid ? 'danger' : 'primary'}} pl-2" *ngIf="icon && !compact"></fal>
    <ng-container *ngIf="label && !compact">
        <ng-container *ngIf="!read || readView !== 'simplified'; else simplifiedLabel">
            <label [class.wide]="wide"
                   [class.narrow]="narrow"
                   [class.d-inline-block]="read">
                {{label}}
            </label>
        </ng-container>
        <ng-template #simplifiedLabel>
            <strong [class.d-inline-block]="read">
                {{label}}
            </strong>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="termSearch">
        <small class="mr-2 text-muted" style="min-width: 80px">Searching for</small>
    </ng-container>
    <ng-container *ngIf="!read; else readTmp">
        <ng-select #input
                   *ngIf="type == 'select'"
                   (click)="stopSelectPropagation($event)"
                   (ngModelChange)="onNgModelChange($event)"
                   (focus)="focus = true"
                   (blur)="onBlur()"
                   (close)="onClose($event)"
                   [ngModel]="_model"
                   [items]="selectItems"
                   [multiple]="multi"
                   [typeahead]="typeahead"
                   (search)="onSearch($event)"
                   [bindValue]="bindValue"
                   [bindLabel]="bindLabel"
                   [groupBy]="groupBy"
                   [selectableGroup]="selectableGroup"
                   [selectableGroupAsModel]="selectableGroupAsModel"
                   [placeholder]="placeholder"
                   [required]="required"
                   [disabled]="disabled"
                   [compareWith]="compareWith"
                   [clearable]="clearable"
                   [searchFn]="searchFn"
                   [virtualScroll]="virtualScroll"
                   (clear)="clear.next()"
                   [class.purified]="variant !== 'form-group'">
            <ng-template ng-option-tmp let-option="item">
                <app-select-option [option]="option"
                                   [searchTerm]="input.searchTerm"
                                   [bindValue]="bindValue"
                                   [bindLabel]="bindLabel"
                                   [bindCode]="bindCode"
                                   [bindSameAs]="bindSameAs">
                </app-select-option>
            </ng-template>
            <ng-container *ngIf="allowSavingNewId">
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm" >
                    <div class="ng-option" (click)="saveNewValue(searchTerm)">
                        No {{itemName || 'item'}} found. Click here to save <strong>{{searchTerm}}</strong>.
                    </div>
                </ng-template>
            </ng-container>
        </ng-select>
        <ng-container *ngIf="type == 'textarea'">
            <div #input
                 editable="true"
                 propValueAccessor="innerText"
                 unformattedPaste
                 class="textarea"
                 [class.form-control]="variant === 'form-group'"
                 [ngModel]="_model"
                 (focus)="focus = true"
                 (blur)="onBlur()"
                 (ngModelChange)="onNgModelChange($event)"
                 (keydown)="onKeyDown($event)"
                 (paste)="onPaste($event)"
                 [attr.maxlength]="limit || null"
                 [attr.placeholder]="placeholder || null"
                 [style.minHeight]="rows ? rows * 1.5 + 'em' : null"
                 [disabled]="disabled"
                 [required]="required">
            </div>
        </ng-container>
        <input #input
               *ngIf="inputType && !type.includes('date') || type == 'input'"
               [(ngModel)]="_model"
               (ngModelChange)="onNgModelChange($event)"
               (focus)="focus = true"
               (blur)="onBlur()"
               [type]="inputType"
               [disabled]="disabled"
               [class.form-control]="variant === 'form-group'"
               [class.text-right]="align == 'right'"
               [class.text-center]="align == 'center'"
               [attr.maxlength]="limit || null"
               [attr.placeholder]="placeholder || null"
               [attr.step]="step"
               [attr.min]="min"
               [attr.max]="max"
               [required]="required">
        <datepicker-select #input
                           *ngIf="type == 'date' || type == 'datetime'"
                           (dateChange)="onNgModelChange($event)"
                           [date]="_model"
                           [format]="type == 'datetime' ? 'date' : 'text'"
                           [hasTime]="type == 'datetime'"
                           [needsTimezone]="false"
                           [icon]="null"
                           [placeholder]="placeholder"
                           [clearable]="clearable"
                           [controlClass]="variant === 'form-group' ? 'form-control' : 'purified'">
        </datepicker-select>
        <app-toggle #input
                    *ngIf="type == 'checkbox'"
                    (ngModelChange)="onNgModelChange($event)"
                    [ngModel]="_model"
                    [label]="compact ? placeholder : null"
                    [disabled]="disabled">
        </app-toggle>
    </ng-container>
    <ng-template #readTmp>
        <span [class]="variant === 'form-group' ? 'form-control-plaintext' : 'value-caption'">
            <ng-container *ngIf="type == 'checkbox'; else captionTmp">
                <fas *ngIf="_model === true" i="check" class="text-success"></fas>
                <fas *ngIf="_model === false" i="times" class="text-danger"></fas>
            </ng-container>
            <ng-template #captionTmp>
                <span class="preserve-newline">{{caption}}</span>
            </ng-template>
        </span>
    </ng-template>
    <div *ngIf="suffix" class="ml-2">{{suffix}}</div>
    <div *ngIf="error" class="text-danger ml-2" style="line-height: 1.2">{{error}}</div>
    <div *ngIf="!read && (limit || charCount)"
         [class]="'ml-2 text-' + (limit && _model?.length > limit ? 'danger' : limit && _model?.length == limit ? 'warning' : 'muted')">{{_model?.length || 0}}{{limit ? '/' + limit : ''}}</div>
    <ng-content></ng-content>
    <ng-container *ngIf="!read && hasDictationPermission">
        <app-action-icon *ngIf="!isListening"
                         icon="microphone"
                         colorClass="secondary"
                         tooltip="Start dictation"
                         class="ml-2"
                         style="margin-top: -.25em; margin-bottom: -.25em;"
                         (click)="startSpeechToText($event)"
                         (mouseenter)="saveSelection()"
                         (mouseleave)="textSelection = null">
        </app-action-icon>
        <span *ngIf="isListening"
              class="ml-2 position-relative"
              style="margin-top: -.25em; margin-bottom: -.25em;">
            <div class="tooltip bs-tooltip-top guide-tooltip show tooltip-primary" role="tooltip">
                <div class="tooltip-inner">Listening</div>
                <div class="arrow"></div>
            </div>
            <app-action-icon icon="stop"
                             colorClass="primary"
                             tooltip="Stop dictation"
                             placement="bottom"
                             [active]="true"
                             [pulsating]="true"
                             (click)="stopSpeechToText($event)">
            </app-action-icon>
        </span>
    </ng-container>
    <span *ngIf="textClearable"
          title="Clear"
          class="custom-select-clear"
          (click)="onNgModelChange(null)">
        ×
    </span>
    <app-hint *ngIf="!read && hint">{{hint}}</app-hint>
</ng-template>

<ng-container *ngIf="!read || readView !== 'simplified'">
    <ng-container *ngTemplateOutlet="tmp"></ng-container>
</ng-container>
<ng-container *ngIf="read && readView === 'simplified'">
    <p class="m-0 flex-grow-1">
        <ng-container *ngTemplateOutlet="tmp"></ng-container>
    </p>
</ng-container>
